<template>
  <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.31435 9.37674L7.25115 7.43994L12.4999 12.6887L17.7487 7.43994L19.6855 9.37674L12.4999 16.5599L5.31435 9.37674Z"
      class="fill-current"
    />
  </svg>
</template>
